



















import Vue from 'vue';
import { addAssignment } from '@/repository/assignment';

export default Vue.extend({
  data: () => ({
    dialog: false,
    name: '',
  }),
  methods: {
    create() {
      addAssignment({
        title: this.name,
      }).then((id) => {
        this.dialog = false;
        this.$router.push(`/assignment/${id}`);
      }).catch((err) => {
        console.error('Error creating assignment: ', err);
      });
    },
  },
});
